import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ISegment, ISearchCriteriaFilter } from '../../../sessions/segments.service';
import { IRegistrationField } from '../../../../models/registrationField';

@Component({
  selector: 'segment-edit',
  templateUrl: './segment-edit.component.html',
  styleUrls: ['./segment-edit.component.scss']
})
export class SegmentEditComponent implements OnChanges {
  @Input() segment: ISegment;
  @Input() registrationFields: IRegistrationField[] = [];
  @Output() segmentChange = new EventEmitter<ISegment>();

  public name = '';
  public criteria: ISearchCriteriaFilter[] = [];

  // Criterion modal
  public showCriteriaModal = false;
  public editingCriterionIndex: number | null = null;
  public criterionField = '';
  public criterionOperator = '==';
  public criterionValue = '';

  ngOnChanges(changes: SimpleChanges) {
    if (changes.segment && this.segment) {
      this.name = this.segment.name || '';
      this.criteria = this.segment.search_criteria ? [...this.segment.search_criteria.filters] : [];
    }
  }

  get selectedRegistrationField(): IRegistrationField | null {
    if (!this.criterionField) return null;
    return this.registrationFields.find(f => f.name === this.criterionField) || null;
  }

  private emit() {
    this.segmentChange.emit({
      ...this.segment,
      name: this.name,
      search_criteria: { filters: this.criteria }
    });
  }

  public onNameChange() {
    this.emit();
  }

  public openAddCriterionModal() {
    this.editingCriterionIndex = null;
    this.criterionField = '';
    this.criterionOperator = '==';
    this.criterionValue = '';
    this.showCriteriaModal = true;
  }

  public openEditCriterionModal(index: number) {
    const c = this.criteria[index];
    this.editingCriterionIndex = index;
    this.criterionField = c.field;
    this.criterionOperator = c.operator;
    this.criterionValue = c.value;
    this.showCriteriaModal = true;
  }

  public closeCriteriaModal() {
    this.showCriteriaModal = false;
    this.editingCriterionIndex = null;
    this.criterionField = '';
    this.criterionOperator = '==';
    this.criterionValue = '';
  }

  public saveCriterion() {
    if (!this.criterionField || !this.criterionValue) return;
    const criterion: ISearchCriteriaFilter = {
      field: this.criterionField,
      operator: this.criterionOperator,
      value: this.criterionValue,
    };
    if (this.editingCriterionIndex !== null) {
      this.criteria[this.editingCriterionIndex] = criterion;
    } else {
      this.criteria.push(criterion);
    }
    this.closeCriteriaModal();
    this.emit();
  }

  public deleteCriterion(index: number) {
    this.criteria.splice(index, 1);
    this.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/email/segments/segment-edit/segment-edit.component.ts